import cGridView from './cGridView.vue';
import cGridViewCol from './cGridViewCol.vue';

export default {
  install(Vue) {
    Vue.component('cGridView', cGridView);
    Vue.component('cGridViewCol', cGridViewCol);
  },
};
